// extracted by mini-css-extract-plugin
export default {"action":"OfferFileRow_action__wloFV","link":"OfferFileRow_link__pBlmC","delete":"OfferFileRow_delete__ivNwH"};